(function () {
  'use strict';

  angular
    .module('leaveDetailReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('leaveDetailReport', {
        url: '/leave-detail-report',
       views:{
          'leaveDetailReportView':{
            templateUrl: 'leave-detail-report/views/leave-detail-report.tpl.html',
            controller: 'LeaveDetailReportCtrl',
            controllerAs: 'leaveDetailReport'
          }
       }
      });
  }
}());
